import { render, staticRenderFns } from "./administrador.vue?vue&type=template&id=154b36e0&scoped=true"
import script from "./administrador.vue?vue&type=script&lang=js"
export * from "./administrador.vue?vue&type=script&lang=js"
import style0 from "./administrador.vue?vue&type=style&index=0&id=154b36e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b36e0",
  null
  
)

export default component.exports